<template>
  <div class="columns" v-if="demandeLogistique">
    <div class="column is-4">
      <information-demande :demandeLogistique="demandeLogistique"></information-demande>
    </div>
    <div class="column is-8">
      <affectation-reseau-lc
        @makeRecherche="$emit('makeRecherche', $event)"
        :demandeLogistique="demandeLogistique" :affectations="affectations" :filtres="filtres">
      </affectation-reseau-lc>
    </div>
  </div>
</template>

<script>
import informationDemande from '@/components/logistique/affectation/informationDemande';
import affectationReseauLc from '@/components/logistique/affectation/affectationReseauLc';

export default {
  name: 'affectationOfCommande',
  props: {
    demandeLogistique: {
      required: true,
      type: Object,
    },
    affectations: {
      required: true,
      type: Array,
    },
    filtres: {
      required: true,
      type: Object,
    },
  },
  components: {
    informationDemande,
    affectationReseauLc,
  },
};
</script>

<style scoped>

</style>
